import { PromoUploadStatusType } from '@entities/adCampaign';
import { MediaUploaderItemType } from '@zvuk-b2b/react-uikit/ui/MediaUploader';
import FileUtils from 'application/utils/FileUtils';

export const toMediaUploaderItem = (item: PromoUploadStatusType): MediaUploaderItemType => {
  const source = FileUtils.getMediafileSource(item.sourcefiles);

  return {
    label: item.file?.name || item.title || '',
    isLoading: item.isLoading,
    error: item.error,
    value: {
      id: item.id || '',
      filename: item.filename || '',
      url: source?.url ?? '',
      previewUrl: item.previewUrl || '',
      duration: item.duration,
      extension: source?.extension,
    },
  };
};
